<template>
  <div class="pa-10">


    <title-page icon="ico-carplug">
      {{ $tc('electricity-tariff.electricity-tariff', 2) }}
    </title-page>

    <v-breadcrumbs
        :items="[
            {text: $tc('electricity-index.electricity-index', 2), to: {name: 'electricity-index'}, exact: true},
            {text: electricityIndex?.name},
        ]"
        divider=">"
    ></v-breadcrumbs>

    <v-row v-if="currentUser.permissions.includes('OPERATOR_WRITE')">
      <v-col class="text-right">
        <v-btn :to="{name: 'electricity-tariff.add'}">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('electricity-tariff.add')}}
        </v-btn>
      </v-col>
    </v-row>


    <v-row no-gutters class="mt-10">
      <v-col>
        <v-data-table
            class="cp-list"
            :headers="headers"
            :items="items"
            :loading="loading"
            :options.sync="options"
            :server-items-length="total"
        >
          <template #item.validityStartDate="{value}">
            {{ value|formatDate($t('format_date')) }}
          </template>
          <template #item.validityEndDate="{value}">
            {{ value|formatDate($t('format_date')) }}
          </template>

          <template #item.options="{item}">
            <v-btn icon :to="{name: 'electricity-tariff.edit', params: {id: item.id}}">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>






  </div>
</template>

<script>


import CustomerRepository from "@repository/CustomerRepository";
import ExportDefault from "@blocks/ExportDefault.vue";
import ElectricityIndexRepository from "@repository/ElectricityIndexRepository";
import ElectricityTariffRepository from "@repository/ElectricityTariffRepository";

export default {
  components: {

  },
  data() {
    return {
      electricityIndex: null,
      loading: false,
      items: [],
      total: 0,
      options: {
        sortBy: ['validityStartDate'],
        sortDesc: [true]
      },

    }
  },

  mounted() {
    if(!this.currentUser.permissions.includes('OPERATOR_READ')) {
      this.$router.replace({name: 'dashboard'})
      return
    }
    this.loadElectricityIndex()
  },

  watch: {


    options() {
      this.searchData()
    }
  },

  computed: {
    headers() {
      return [
        {text: this.$t('electricity-tariff.validity-start-date'), value: 'validityStartDate'},
        {text: this.$t('electricity-tariff.validity-end-date'), value: 'validityEndDate'},
        {text: this.$t('electricity-tariff.value-per-kwh'), value: 'valuePerKWh'},
        {text: '', value: 'options'},
      ]
    },

    electricityIndexId() {
      return this.$route.params.electricityIndexId
    },
  },

  methods: {

    loadElectricityIndex() {
      ElectricityIndexRepository.get(this.electricityIndexId).then(result => {
        this.electricityIndex = result
      }).catch(err => {
        this.notifyError(err)
      })
    },


    searchData() {

      let options = this.options


      this.loading = true
      let offset = options.itemsPerPage * options.page - options.itemsPerPage;
      let limit = options.itemsPerPage;
      let orderBy = options.sortBy.length > 0 ? options.sortBy[0] : null
      let orderDirection = options.sortDesc.length > 0 && options.sortDesc[0] ? 'desc' : 'asc'




      this.loading = true
      ElectricityTariffRepository.search(
          this.electricityIndexId,
          offset,
          limit,
          orderBy,
          orderDirection,
      ).then(result => {
        this.total = result.total
        this.items = result.items
        this.loading = false
      }).catch(err => {
        this.notifyError(err)
        this.loading = false
      })
    },

  }
}
</script>

<style lang="scss">


</style>
